{
    "Messages_Type_Label": "Tipo de mensagem",
    "Messages_Language_Label": "Linguagem",
    "Messages_Language_DefaultOption": "Padrão \/ Alternativa",
    "Messages_Subject_Label": "Assunto",
    "Messages_PlainBody_Label": "Corpo (texto simples)",
    "Messages_HtmlBody_Label": "Corpo (HTML)",
    "Messages_NewLocale_Info": "Ao salvar, uma nova entrada de mensagem será criada para este idioma.",
    "Messages_Action_Save": "Salvar",
    "Messages_Action_Revert": "Reverter",
    "Messages_Action_Delete": "Excluir",
    "Messages_DiscardChanges_Prompt": "Descartar alterações não salvas?",
    "Messages_DiscardChanges_Confirm": "Descartar alterações",
    "Messages_DiscardChanges_Cancel": "Continue editando",
    "Messages_Save_Success": "Mensagem salva.",
    "Messages_Save_Error": "Não foi possível salvar a mensagem.",
    "Messages_Delete_Success": "Mensagem apagada.",
    "Messages_Delete_Error": "Não foi possível apagar a mensagem.",
    "NAME": "MensagensIdioma"
}